export default __webpack_public_path__ + "static/media/workoutHealthgenom.2cf25f3e.svg";